export default __webpack_public_path__ + "static/media/ic-fee.ea0e2b83.svg";